// extracted by mini-css-extract-plugin
export var billingAddress = "_qu-g";
export var contactInfo = "_qu-d";
export var customerInfoContainer = "_qu-c";
export var customerInfoContainerMobile = "_qu-h";
export var customerInfoRow = "_qu-a";
export var customerInfoSection = "_qu-b";
export var fullWidthDividerMobile = "_qu-i";
export var imageContainer = "_qu-1";
export var paymentMethod = "_qu-e";
export var priceText = "_qu-6";
export var priceTextMobile = "_qu-7";
export var product = "_qu-0";
export var productImage = "_qu-2";
export var productInfo = "_qu-4";
export var productMobile = "_qu-9";
export var productTitle = "_qu-8";
export var quantityBadge = "_qu-3";
export var quantityText = "_qu-5";
export var shippingAddress = "_qu-f";